import ReactDOM from "react-dom/client";

import App from "./App";
import reportWebVitals from "./reportWebVitals";
import config from "devextreme/core/config";
import "./index.css";
import "./themes/dx.generic.ap-custom-scheme.css";
import "./themes/dx.generic.ap-custom-scheme-extertion-expansion.css";

var licenseKey = process.env.REACT_APP_DEVEXTREME_KEY;
config({ licenseKey });

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(<App />);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
